import { SingleInstance } from "@ploy-ui/core";

export default function SingleInstanceDealerWeb({
	id = "dealer-web"
}: {
	id?: string;
}) {
	const shouldEnable = ["true", "yes", "on"].includes(
		(window as any).env?.REACT_APP_SINGLE_INSTANCE_DEALERWEB_PORTAL
	);
	return shouldEnable ? <SingleInstance id={id} /> : <></>;
}
